// ------------------ IMPORTS -------------------

// Components
import { TableDndV2 } from "#src/commonV2/Table/variants/DragNDrop";

// Child Components
import { usePassportTableActions } from "./hooks/usePassportTableActions";
import { usePassportTableColumns } from "./hooks/usePassportTableColumns";

// Others
import { Dispatch, SetStateAction } from "react";
import { IPassport } from "#src/services/endpoint/passports/types";

type Props = {
  workspaceId: string;
  passportList: IPassport[];
  setPassportList: Dispatch<SetStateAction<IPassport[]>>;
  isLoading: boolean;
  setIsAddEditModalOpen: (open: boolean) => void;
  setIsDeleteModalOpen: (open: boolean) => void;
  setSelectedPassport: (passport: IPassport | null) => void;
  canDnd: boolean;
  canEdit: boolean;
};

export const PassportTable = (props: Props) => {
  const {
    workspaceId,
    passportList,
    setPassportList,
    isLoading,
    setIsAddEditModalOpen,
    setIsDeleteModalOpen,
    setSelectedPassport,
    canDnd,
    canEdit,
  } = props;

  // ------------------ HOOKS -------------------

  const { switchingItem, getTableActions, onToggleStatus, onSwapPriority } =
    usePassportTableActions({
      workspaceId,
      setPassportList,
      setIsAddEditModalOpen,
      setIsDeleteModalOpen,
      setSelectedPassport,
      canEdit,
    });

  const { columns } = usePassportTableColumns({
    switchingItem,
    canEdit,
    getTableActions,
    onToggleStatus,
  });

  // ------------------ RENDER -------------------

  return (
    <TableDndV2<IPassport>
      data={passportList}
      getRowKey={(item) => item.id.toString()}
      isLoading={isLoading}
      columns={columns}
      options={{
        fitPageHeight: true,
      }}
      onDragEnd={onSwapPriority}
      disabledDnd={!canDnd}
    />
  );
};
